import { observer } from "mobx-react";
import { FilterTag } from "../FilterTag";
import { useStores } from "../../../../../shared/stores/RootStore";
import { hlaAttributeFiltersToString } from "../../../../../map/models/MapFilters";
import { t } from "i18next";

const HlaAttributeFiltersTagsBase = () => {
  const { filterStore, projectStore } = useStores();
  const filters = filterStore.hlaAttributeFilters;

  const filtersStr = Object.entries(hlaAttributeFiltersToString(filters));

  return (
    <>
      {filtersStr.map(([name, value]) => (
        <FilterTag
          key={name}
          onClose={() => {
            const newFilters = { ...filters };

            if (name === "averageRoadSpeed" || name === "averageDailyTraffic") {
              newFilters[name] = { min: null, max: null };
            } else {
              (newFilters as any)[name] = [];
            }

            filterStore.setHlaAttributeFilters(newFilters);
          }}
        >
          {`${t(`shared:hlaAttribute.${name}`, {
            speedUnit: projectStore.speedUnitStr,
          })}: ${value}`}
        </FilterTag>
      ))}
    </>
  );
};

export const HlaAttributeFiltersTags = observer(HlaAttributeFiltersTagsBase);
